export default __webpack_public_path__ + "static/media/us-al.b66e4422.svg";